module.exports = __webpack_public_path__ + "28f3e423e562f5a06b46edc105b7df65.jpg";